var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
window._WS_COMPONENTS_PACKAGE_TARGET = 'vue3';
// eslint-disable-next-line max-lines-per-function
export var generateProxy = function (app, name, component, uiRender) {
    app.component(name, component);
    return {
        // @ts-ignore
        __isTeleport: true,
        // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
        process: function (oldNode, newNode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
            var _this = this;
            var _a, _b, _c, _d;
            var patch = internals.p;
            var slotNames = {};
            var childrenNum = typeof ((_a = newNode === null || newNode === void 0 ? void 0 : newNode.children) === null || _a === void 0 ? void 0 : _a.length) === 'number' ? newNode.children.length : 0;
            for (var i = 0; i < childrenNum; i++) {
                var slotName = ((_b = newNode.children[i].props) === null || _b === void 0 ? void 0 : _b['portal-name']) || 'default';
                slotNames[slotName] = slotNames[slotName] || [];
                slotNames[slotName].push(i);
            }
            var updateRef = function () {
                var _a;
                if (typeof newNode.props.ref !== 'string') {
                    return;
                }
                parentComponent.refs = __assign(__assign({}, parentComponent.refs), (_a = {}, _a[newNode.props.ref] = null, _a));
                Object.defineProperty(parentComponent.refs, newNode.props.ref, {
                    enumerable: true,
                    get: function () { return newNode.cmp_vm; },
                    set: function (_val) { }
                });
            };
            var requestSlot = function (slotName) {
                if (!slotNames[slotName]) {
                    return false;
                }
                return function (slot) { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = newNode.children[0];
                                return [4 /*yield*/, slot.getContainer];
                            case 1:
                                _a.target = _b.sent();
                                slotNames[slot.name].forEach(function (index) {
                                    var _a, _b, _c;
                                    if ((_b = (_a = newNode.children[index]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b['portal-slot-props']) {
                                        Object.keys(slot.attrs).forEach(function (key) {
                                            newNode.children[index].props['portal-slot-props'][key] = slot.attrs[key];
                                        });
                                    }
                                    var oldChild = ((_c = oldNode === null || oldNode === void 0 ? void 0 : oldNode.children) === null || _c === void 0 ? void 0 : _c[index]) || null;
                                    patch(oldChild, newNode.children[index], slot.getContainer(), slot.getAnchor(), parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                                });
                                return [2 /*return*/];
                        }
                    });
                }); };
            };
            // First render
            if (oldNode === null) {
                var _e = uiRender.mountComponent({
                    name: name,
                    attrs: newNode.props,
                    requestSlot: requestSlot,
                    getContainer: function () { return container; },
                    getAnchor: function () { return anchor; },
                    slots: Object.keys(slotNames),
                    component: component
                }), id = _e.id, vm = _e.vm;
                newNode.cmp_id = id;
                newNode.cmp_vm = vm;
                if (((_c = newNode.props) === null || _c === void 0 ? void 0 : _c.ref) && typeof ((_d = newNode.props) === null || _d === void 0 ? void 0 : _d.ref) === 'string') {
                    parentComponent.refs[newNode.props.ref] = vm;
                    newNode.ref = parentComponent.refs[newNode.props.ref];
                    updateRef();
                }
            }
            else { // Rerender
                newNode.cmp_id = oldNode.cmp_id;
                newNode.cmp_vm = oldNode.cmp_vm;
                newNode.ref = oldNode.ref;
                if (newNode.props.ref) {
                    updateRef();
                }
                // Update Props
                uiRender.update(oldNode.cmp_id, newNode.props, requestSlot);
            }
        },
        remove: function (vnode) {
            uiRender.unMountComponent(vnode.cmp_id);
        }
    };
};
